export const CONTACT_SERVICES = [
  { id: "line-mini-app", group: "LINE", name: "LINEミニアプリ開発" },
  { id: "line-chatbot", group: "AI", name: "AIチャットボット開発" },
  { id: "ax-consulting", group: "AI", name: "AX支援・AI導入支援" },
  { id: "yoshinani-shindan", group: "AI", name: "よしなに診断" },
  { id: "yoshinani-brick", group: "Brick", name: "LEGOブロック制作" },
  { id: "3d-print", group: "Brick", name: "3Dプリント制作" },
] as const

export type ContactServiceId = (typeof CONTACT_SERVICES)[number]["id"]
/** 公開ページのURLとフォームのサービスIDを一箇所で対応付ける。 */
export function serviceHref(id: string): string {
  return id === "ax-consulting" ? "/business/ai#ax-support" : `/business/${id}`
}

export type ContactPurpose = "materials" | "consultation"

const MATERIAL_DETAILS: Partial<
  Record<ContactServiceId, { name: string; description: string }>
> = {
  "line-mini-app": {
    name: "LINEミニアプリ開発資料",
    description: "開発サービス・機能・料金・公開実績・依頼の進め方",
  },
  "yoshinani-brick": {
    name: "LEGO制作実績・メニュー表",
    description: "制作実績・対応サイズ・AI活用・制作メニュー・見積もりの条件",
  },
}

/** 相談時のサービス名と、配布する資料の名称を分ける。 */
export function getContactMaterial(service: (typeof CONTACT_SERVICES)[number]) {
  return (
    MATERIAL_DETAILS[service.id] ?? {
      name: service.name,
      description: undefined,
    }
  )
}

export const CONTACT_TOPICS = [
  { id: "business", name: "サービスのご相談・お見積もり" },
  { id: "partnership", name: "協業・パートナーについて" },
  { id: "brand", name: "ロゴ・ブランド素材の利用について" },
  { id: "other", name: "その他" },
] as const

export const CONTACT_GENRES = [
  ...CONTACT_SERVICES,
  ...CONTACT_TOPICS.filter(({ id }) => id !== "business"),
] as const

export function contactHref(service?: ContactServiceId) {
  return service ? `/contact?service=${service}` : "/contact"
}

export function materialsHref(service?: ContactServiceId) {
  return `/materials${service === "line-mini-app" || service === "yoshinani-brick" ? `#${service}` : ""}`
}
